import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Grid,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ApplicantDetailsPreviewROWResponse } from "../application-preview/types";
dayjs.extend(customParseFormat);

export const IndividualDetailsROW: React.FC<{
  isExpanded: boolean;
  visible?: boolean;
  toggleExpand: () => void;
  data: ApplicantDetailsPreviewROWResponse;
}> = ({ isExpanded, toggleExpand, data }) => {
  if (!data) return null;
  const { user } = data;
  if (!user) return null;
  const {
    applicant_name,
    email_address,
    mobile_number,
    pan_number,
    aadhaar_number,
    address,
    date_of_birth,
    district,
    state,
    pincode,
  } = user;

  const displayValue = (val: any) => {
    if (val === true) return " Yes";
    if (val === false) return " No";
    if (val === "" || val === null || val === undefined) return "NA";
    return val;
  };

  const formatDateString = (dateStr?: string) => {
    if (!dateStr) return dateStr;

    // ✅ already in DD/MM/YYYY → return as is
    if (dayjs(dateStr, "DD/MM/YYYY", true).isValid()) {
      return dateStr;
    }

    // ✅ backend sends 8-digit DOB (DDMMYYYY)
    if (/^\d{8}$/.test(dateStr)) {
      return `${dateStr.slice(0, 2)}/${dateStr.slice(2, 4)}/${dateStr.slice(
        4,
      )}`;
    }

    // ✅ ISO or other valid formats
    if (dayjs(dateStr).isValid()) {
      return dayjs(dateStr).format("DD/MM/YYYY");
    }

    return dateStr; // fallback
  };

  const details = [
    { label: "Applicant Name", value: displayValue(applicant_name) },
    // { label: "Aadhar No", value: displayValue(aadhaar_number) },
    { label: "Mobile Number", value: displayValue(mobile_number) },
    // { label: "Pan Number", value: created_by_uname },
    // { label: "Pan Number", value: displayValue(pan_number) },
    { label: "Email Address", value: displayValue(email_address) },
    { label: "Address", value: displayValue(address) },
    {
      label: "Date of Birth",
      value: date_of_birth ? formatDateString(date_of_birth) : "NA",
    },
    ...(district ? [{ label: "District", value: district }] : []),
    ...(state ? [{ label: "State", value: state }] : []),
    ...(pincode ? [{ label: "Pin Code", value: pincode }] : []),
    // { label: "GST No", value: "BHNHJGU453CFGHTYD" },
  ];

  const detailsLayout = [
    [details[0], details[1]],
    [details[2], details[3]],
    [details[4], details[5]],
    [details[6], details[7]],

    // [details[6]],
  ];

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <Card sx={{ boxShadow: "none", border: "1px solid #E7E8E9" }}>
        {/* Header */}
        <Box
          sx={{
            backgroundColor: "#F4F2F7",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E7E8E9",
            pl: 2,
            py: "5px",
          }}
        >
          <Typography
            sx={{ fontSize: 12 }}
            fontWeight="semi-bold"
            className="preview-dropdown-header"
          >
            Applicant Individual Details
          </Typography>
          <IconButton aria-label="Collapse section" onClick={toggleExpand}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </Box>

        {/* Content */}
        {isExpanded && ( // Conditionally render the content
          <CardContent>
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12} spacing={1}>
                <Box
                  sx={{
                    display: { xs: "block", sm: "flex" },
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  {detailsLayout.map((row, rowIndex) => (
                    <Box
                      key={`row-${rowIndex}`}
                      sx={{
                        display: { xs: "block", sm: "flex" },
                        justifyContent: "space-between",
                        gap: 4,
                      }}
                    >
                      {row.map((detail, colIndex) => (
                        <Box
                          key={`detail-${rowIndex}-${colIndex}`}
                          sx={{ flex: 1 }}
                        >
                          <Typography
                            className="preview-dropdown-label"
                            sx={{
                              fontWeight: "500",
                              mb: 0.5,
                              color: "#878787",
                            }}
                          >
                            {detail?.label}
                          </Typography>
                          <Typography
                            sx={{ fontSize: "1rem" }}
                            className="preview-dropdown-value"
                          >
                            {detail?.value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        )}
      </Card>
    </Box>
  );
};
